import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_v27n87y2qb: FaireBrandEntity = {
  token: "b_v27n87y2qb",
  type: "brand",
  name: "Candle Lume",
  avatarUrl:
    "https://cdn.faire.com/fastly/7bc4f8cf7a5d993923edaf182256b5ec11b78d31456ae7248e4c29f5d868aa37.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/e2dd826bd6fc57c9c26838be538d5839d9746bd16c3c64a9518e0dc98b409eb6.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/7bc4f8cf7a5d993923edaf182256b5ec11b78d31456ae7248e4c29f5d868aa37.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/e2dd826bd6fc57c9c26838be538d5839d9746bd16c3c64a9518e0dc98b409eb6.jpeg",
  location: "Aurora, ON, CAN",
  minimumOrderDollars: 50,
  rating: 4.5,
  reviewCount: 58,
  isInsider: false,
  description:
    "At Candle Lume, we craft hyper-realistic food and drink candles for the aesthetic-obsessed. Hand-poured in Canada, these artfully crafted candles are sensory statements designed to delight the eye and the senses, transforming everyday moments into something worth savoring.\n\nFrom perfectly sculpted martini cocktails to market-inspired finds, our candles blur the line between décor and conversation piece. While we celebrate the elegance of cocktail-inspired designs, we also embrace the unexpected with playful, unfiltered, and novelty creations that spark curiosity and add a touch of humor. \n\nArtful and unforgettable, these are candles you’ll be proud to display and share.\n\nOver 3,000 5-Star reviews on Etsy.",
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:14:19.215Z",
    importedBy: "entity-db-cli",
  },
};
